export enum ReportFileType {
  PDF,
  XSLX,
  CSV
}
